import React, { useEffect, useState } from "react";
import { formatMonthYear, maskMonthYearInput, toStoredMonthYear } from "../../utilities/monthYear";
import { DueBadge } from "./DueBadge";

export const MonthYearInput = ({
    value,
    name = undefined,
    onChange = undefined,
    readOnly = false,
    required = false,
    className = "form-control",
    dueConfig = undefined,
}: {
    value: any;
    name?: string;
    onChange?: (stored: string) => void;
    readOnly?: boolean;
    required?: boolean;
    className?: string;
    dueConfig?: any;
}) => {
    const [text, setText] = useState(() => formatMonthYear(value));
    const [dirty, setDirty] = useState(false);

    useEffect(() => {
        const stored = toStoredMonthYear(value);
        if (stored !== toStoredMonthYear(text) && (stored || !value)) {
            setText(formatMonthYear(value));
        }
    }, [value]);

    const stored = toStoredMonthYear(text);
    const hiddenValue = !dirty ? value || "" : stored || (text ? value || "" : "");

    return (
        <>
            <input
                type="text"
                inputMode="numeric"
                placeholder="MM/JJJJ"
                pattern="(0[1-9]|1[0-2])/\d{4}"
                maxLength={7}
                readOnly={readOnly}
                required={required}
                className={className}
                value={text}
                onChange={(ev) => {
                    const next = maskMonthYearInput(ev.currentTarget.value);
                    setText(next);
                    setDirty(true);
                    const nextStored = toStoredMonthYear(next);
                    if (onChange && (nextStored || next === "")) {
                        onChange(nextStored);
                    }
                }}
            />
            {name && <input type="hidden" name={name} value={hiddenValue} />}
            {dueConfig && <DueBadge value={stored || value} config={dueConfig} />}
        </>
    );
};
